
import { defineComponent, PropType, reactive } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Checkbox from '@/common/components/UI/Checkbox/index.vue'

// types
import { CompletedCargoT } from '@/core/types/create_order.types'

// constants
import {
    LTL_SHIPMENT_TYPES_OBJECT,
    PAYMENT_METHODS_OBJECT,
    PAYMENT_TYPES_OBJECT,
} from '@/core/constants/create_order.constants'
import { EMPTY_ADDITIONAL_SERVICES } from '@/core/constants/additional_services.constants'
import { AdditionalByIdT } from '@/core/types/billing.types'

export default defineComponent({
    components: {
        'the-button': TheButton,
        checkbox: Checkbox,
    },
    props: {
        cargo: {
            type: Object as PropType<CompletedCargoT>,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        additionalServices: {
            type: Array as PropType<AdditionalByIdT[]>,
            default: () => [],
        },
        isBosch: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['delete', 'update', 'update-additional-services'],
    setup(props, { emit }) {
        const state = reactive({
            is_opened: false,
            additional_services: { ...EMPTY_ADDITIONAL_SERVICES },
        })

        const open = () => {
            state.is_opened = true
        }

        const close = () => {
            state.is_opened = false
        }

        const emitDelete = () => {
            const answer = confirm(
                `Вы действительно хотите удалить готовый груз №${props.index + 1}?`
            )
            if (!answer) return

            emit('delete', props.index)
        }

        const emitUpdate = () => {
            emit('update', props.index)
        }

        const emitUpdateAdditionalServices = () => {
            emit('update-additional-services', {
                index: props.index,
                additional_services: { ...state.additional_services },
            })
        }

        const getValue = (service_name: string, key: keyof AdditionalByIdT) => {
            const service = props.additionalServices.find((s) => s.name === service_name)
            if (!service) return '-'
            return service[key]
        }

        return {
            LTL_SHIPMENT_TYPES_OBJECT,
            PAYMENT_METHODS_OBJECT,
            PAYMENT_TYPES_OBJECT,
            state,
            open,
            close,
            emitDelete,
            emitUpdate,
            emitUpdateAdditionalServices,
            getValue,
        }
    },
})
